import React from "react";
import {
  EditIconDarkGray,
  EditIconGray,
  TrashIconGray,
} from "../../constant/imagePath";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import { Button } from "../Button/Button";
import classes from "./AddedLocationCard.module.css";

function AddedLocationCard({ data, onDelete, onEdit }) {
  return (
    <div className={classes.addedLocation} key={data?._id}>
      <div className={classes.left}>
        <img src={data?.img} />
        <div className={classes.description}>
          <span
            style={{
              ...Fonts.otherMedium,
              color: Colors.neutralShadesOfDimGray,
            }}
            className={classes.address}
          >
            {data?.address}
          </span>
          <h6
            style={{
              ...Fonts.h7,
              color: Colors.neutralShadesOfNero,
              lineHeight: "24px",
            }}
          >
            {data?.venueName}
          </h6>
          <p
            style={{
              ...Fonts.p1,
              color: Colors.neutralShadesOfDimGray,
            }}
          >
            {`${data?.state + " , "}`}
            {`${data?.city + " , "}`}
            {data?.country}
          </p>
        </div>
      </div>
      <div className={classes.right}>
        <Button
          icon={TrashIconGray}
          onClick={() => onDelete(data?._id)}
          primary={false}
          customStyle={{
            border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
            marginRight: "8px",
          }}
          size={"Small"}
        />
        <Button
          icon={EditIconDarkGray}
          onClick={() => onEdit(data)}
          primary={false}
          customStyle={{
            border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
          }}
          size={"Small"}
        />
      </div>
    </div>
  );
}

export default AddedLocationCard;
